<template>
  <div class="circle-stage">
    <div class="ornament"></div>
    <div class="wrapper">
      <div class="content">
        <h1>
          <slot name="headline"></slot>
        </h1>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircleStage',
};
</script>

<style lang="scss" scoped>
.circle-stage {
  position: relative;
  margin-bottom: var(--spacing-side);

  .ornament {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;

    &:before {
      content: "";
      display: block;
      position: absolute;
      width: 200%;
      height: 200%;
      border-radius: 100%;
      background-color: var(--colors-primary-dimmed);
      transform: translate(-25%, -50%);
    }
  }

  .wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    min-height: 30vh;

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      width: 100%;
      max-width: var(--spacing-width-max);
      height: 100%;
      margin: auto;
      padding: calc(2 * var(--spacing-side)) var(--spacing-side) calc(3 * var(--spacing-side));
      box-sizing: border-box;
      text-align: center;

      h1 {
        margin-top: 0;
        margin-bottom: 0;
        font-size: 1.5rem;
        font-weight: 600;
      }
    }
  }
}
</style>
